type GpsStatus = "capturado" | "indisponivel" | "buscando" | "baixa_precisao";

interface GpsStatusBadgeProps {
  status: GpsStatus;
  precisao?: number;
}

const statusConfig: Record<GpsStatus, { label: string; bg: string; icon: string; text: string }> = {
  capturado: { label: "GPS OK", bg: "bg-[#CAF0D3]", icon: "ri-gps-line", text: "text-[#1B6E4F]" },
  indisponivel: { label: "GPS Indisp.", bg: "bg-[#E8EAED]", icon: "ri-gps-fill", text: "text-[#D32F2F]" },
  buscando: { label: "Buscando GPS...", bg: "bg-[#64B5F6]/20", icon: "ri-radar-line animate-pulse", text: "text-[#0052CC]" },
  baixa_precisao: { label: "Precisão baixa", bg: "bg-[#FFF3E0]", icon: "ri-error-warning-line", text: "text-[#F57C00]" },
};

export default function GpsStatusBadge({ status, precisao }: GpsStatusBadgeProps) {
  const cfg = statusConfig[status];
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${cfg.bg} ${cfg.text}`}>
      <i className={`${cfg.icon} text-xs`} />
      {cfg.label}
      {precisao !== undefined && <span className="ml-0.5 opacity-80">±{Math.round(precisao)}m</span>}
    </span>
  );
}